import { httpGet, httpPost } from '../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../constants/constants';

export const getPlayerByPlayerId = (playerId, token) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/${playerId}`);

  return httpGet(`${url.href}`, {}, token)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      const txt = 'Something went wrong... cant get player by player id';
      alert(txt);
      throw new Error(txt, error);
    });
};

export const getHomeUserByHomeUserId = (homeUserId) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/users/${homeUserId}`);

  return httpGet(`${url.href}`, {})
    .then((result) => {
      return result;
    })
    .catch((error) => {
      const txt = "Something went wrong... can't get home user by home user id";
      alert(txt);
      throw new Error(txt, error);
    });
};

export const updateHomeUser = (fields) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/users/upsert_new_home_user`);

  return httpPost(`${url.href}`, fields)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      const txt = "Something went wrong... can't update home user";
      alert(txt);
      throw new Error(txt, error);
    });
};

export const addNewHomeUser = (fields) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/users/upsert_new_home_user`);

  return httpPost(`${url.href}`, fields)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      const txt = "Something went wrong... can't add new home user";
      alert(txt);
      throw new Error(txt, error);
    });
};
